// extracted by mini-css-extract-plugin
export var productImage = "_p8-1";
export var viewLink = "_p8-2";
export var wishlistItem = "_p8-0";